import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ChevronRight from "@material-ui/icons/ChevronRight";
import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import { scrollTo } from "scroll-js";

const styles = theme => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    margin: "0 auto"
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4
  }
});

class NestedList extends React.Component {
  state = {
    open: true
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  changeHandler = e => {
    const calcBody = document.querySelector(".calc-body");
    calcBody &&
      scrollTo(calcBody, {
        top: 80,
        duration: 1000,
        easing: "ease-out"
      }).then(() => {});

    this.props.filterCities(e.target.value);
  };

  render() {
    const { classes, cityList } = this.props;

    return (
      <List
        component="nav"
        subheader={
          <ListSubheader component="div">
            <span style={{ color: "#1d99b4" }}>
              {this.props.langBase.pickCity}
            </span>
            <div>
              <TextField
                id="outlined-dense"
                type="text"
                ref="postalCode"
                label={this.props.langBase.filter || "Filtruj"}
                name="postalCode"
                className={
                  "inputPostal " + classNames(classes.textField, classes.dense)
                }
                onChange={this.changeHandler}
                margin="dense"
                variant="outlined"
                autoComplete="off"
              />
            </div>
          </ListSubheader>
        }
        className={"cityList " + classes.root}
      >
        {cityList.map((city, i) => {
          return (
            <ListItem
              onClick={() => this.props.pickCity(city.miejscowosc)}
              key={i}
              button
            >
              <ListItemIcon>
                <ChevronRight />
              </ListItemIcon>
              <ListItemText inset primary={city.miejscowosc} />
            </ListItem>
          );
        })}
      </List>
    );
  }
}

NestedList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NestedList);
